<svelte:options accessors/>
<script>
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import NauiFilters from "../../naui/components/NauiFilters.svelte";

    export let data;
    export let options;
    export let columns;
    export let filters;
</script>
<div>
    <div class="py-15">
        <NauiFilters {filters} on:filtered/>
    </div>
    <div>
        <NauiTable data={data.resumen}
               columns={columns.resumen}/>
    </div>
    <div class="mt-2">
        <NauiTable data={data.movimientos}
               columns={columns.movimientos}/>
    </div>
    <div class="mt-2">
        <div class="grid-2">
            <table class="naui-table w-100">
                <tbody>
                    <tr>
                        <td>
                            <div>Metro ingreso</div>
                        </td>
                        <td>
                            <div>{data.metro_ingreso}</div>
                        </td>
                    </tr>
                </tbody>

            </table>
            <table class="naui-table w-100">
                <tbody>
                    <tr>
                        <td>
                            <div>Metro salida</div>
                        </td>
                        <td>
                            <div>{data.metro_salida}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <table class="naui-table w-100">
                <tbody>
                    <tr>
                        <td>
                            <div>Cumplimiento</div>
                        </td>
                        <td>
                            <div><sub>Ventas</sub> {data.cumplimiento.ventas}</div>
                        </td>
                        <td>
                            <div><sub>Presupuesto</sub> {data.cumplimiento.presupuesto}</div>
                        </td>
                        <td>
                            <div><sub>CMPTO</sub> {data.cumplimiento.cumplimiento}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>